import TabberContainer from './tabber_container';

const Tabber = TabberContainer;
export default Tabber;
